/* eslint-disable */
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import updateLocale from 'dayjs/plugin/updateLocale';
import objectSupport from 'dayjs/plugin/objectSupport';
import isBetween from 'dayjs/plugin/isBetween';
import isToday from 'dayjs/plugin/isToday';
import duration from 'dayjs/plugin/duration';
import dayjsCustomPlugin from 'app/libs/dayjsCustomPlugin';
import 'dayjs/locale/ko';

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

dayjs.extend(updateLocale);
dayjs.updateLocale('ko', {
	ordinal: (number) => `${number}일`,
});

dayjs.extend(objectSupport);

dayjs.extend(dayjsCustomPlugin);

dayjs.extend(isBetween);

dayjs.extend(isToday);

dayjs.extend(duration);

export default dayjs;
